interface UploadImageInput {
    fileName?: string;
    fileBase64?: string;
    imageUrl?: string;
    contentType?: string;
}

interface UploadImageResponse {
    success: boolean;
    url?: string;
    error?: string;
}

export async function uploadImageToStorage(input: UploadImageInput): Promise<string> {
    const response = await fetch('/api/storage/upload', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    const responseText = await response.text();
    let result: UploadImageResponse;

    try {
        result = JSON.parse(responseText) as UploadImageResponse;
    } catch {
        throw new Error(responseText.trim() || `京东云 OSS 上传接口请求失败 (${response.status})`);
    }

    if (!response.ok || !result.success || !result.url) {
        throw new Error(result.error || `京东云 OSS 上传失败 (${response.status})`);
    }

    return result.url;
}
